import PropTypes from 'prop-types'
import React from 'react'
import { DropzoneComponent } from 'react-dropzone-component'
import { ImageManager } from 'Core/imageManager'
import { AddBtn } from '../AddBtn'
import { Reminder } from '../Reminder'
import { Preview } from '../Preview'
import { connect } from 'react-redux'
import { getUserInfo, getServiceProviderPhotos } from '../../../../../../selectors'
import {
  updateServiceProviderPhotoByTmpId,
  deleteServiceProviderPhoto,
  saveServiceProviderPhoto,
  updateServiceProviderPhotoById,
  setServiceProviderPhotos
} from '../../../../../../actions'
import { Preloader } from 'SRC/ui/Preloader'
import { imagesCDN } from 'Core/constants'

export class Container extends React.Component {
  constructor (props) {
    super(props)

    this.maxWidth = 1600
    this.maxHeight = 1600
    this.state = {newPhotos: [], isLoading: true, isPhotoCanBeAdded: true}

    this.componentConfig = {
      postUrl: 'no-url'
    }
    this.djsConfig = {
      acceptedFiles: 'image/jpeg,image/png,image/gif',
      autoProcessQueue: false,
      uploadMultiple: true,
      addRemoveLinks: false,
      createImageThumbnails: false,
      previewTemplate: '<div></div>',
      maxFiles: this.props.photoLimit
    }
    this.dropzone = null
    this.imageManager = new ImageManager()
    this.isComponentMounted = true
  }

  async componentDidMount () {
    if (this.props.existingPhotos.length) {
      await this.loadPhotos()
    } else {
      this.setState({...this.state, isLoading: false})
    }
  }

  async componentDidUpdate (prevProps) {
    if (!this.isArraysEquals(this.props.existingPhotos, prevProps.existingPhotos)) {
      await this.loadPhotos(prevProps.existingPhotos)
    }
  }

  componentWillUnmount () {
    this.isComponentMounted = false
  }

  loadPhotos = async (existingPhotos = []) => {
    await this.setState({...this.state, isLoading: true})
    const promises = []
    this.props.existingPhotos.forEach(({id, fd, priority, main}) => {
      const arStrings = fd.split('/')
      const name = arStrings[arStrings.length - 1]
      promises.push(new Promise(resolve => {
        if (existingPhotos.length) {
          const existingPhoto = existingPhotos.filter(item => item.fd === fd)
          if (existingPhoto.length) {
            const loadedPhoto = this.props.photos.filter(photo => photo.id === existingPhoto[0].id)
            if (loadedPhoto.length) {
              resolve({id: loadedPhoto[0].id, name, url: loadedPhoto[0].url, priority, main, isOriginal: true})
            }
          }
        }
        this.imageManager.loadImageFromUrl(`${imagesCDN}${fd}`).then(image => {
          resolve({id, url: image.file, name, priority, main, isOriginal: true})
        }).catch(() => {
          resolve({id, url: '', name, priority, main})
        })
      }))
    })
    await Promise.all(promises).then(photos => {
      if (this.isComponentMounted) {
        this.props.setPhotos(photos.sort((a, b) => a.priority - b.priority))
        this.setState({...this.state, isLoading: false})
      }
    })
  }

  isArraysEquals = (array1 = [], array2 = []) => {
    let isEquals = true
    if (Array.isArray(array1) && Array.isArray(array2) && array1.length === array2.length) {
      const props = ['id', 'fd', 'priority', 'main']
      for (const key in array1) {
        for (const property of props) {
          if (array1[key][property] !== array2[key][property]) {
            isEquals = false
            break
          }
        }
      }
    } else {
      isEquals = false
    }
    return isEquals
  }

  handleFileAdded = image => {
    if (!this.isPhotoLimitExceeded()) {
      this.imageManager.loadImage(image).then(
        file => this.imageManager.resizeImage(file, {width: this.maxWidth, height: this.maxHeight})
      ).then(
        async file => {
          const index = this.props.photos.filter(item => !item.destroy).length
          await this.savePhoto({
            url: file,
            name: image.upload.filename,
            tmpId: image.upload.uuid,
            priority: index,
            main: !index
          }, image)
          this.setState({...this.state, isPhotoCanBeAdded: this.isPhotoCanBeAdded()})
        }
      )
    } else {
      this.dropzone.removeFile(image)
    }
  }

  savePhoto = (meta, originalFile) => {
    this.props.savePhoto(meta)
    this.setState(prevState => {
      const photos = [...prevState.newPhotos]
      photos.push({tmpId: meta.tmpId, file: originalFile})
      return {...prevState, newPhotos: photos}
    })
  }

  handleDragStart = event => {
    this.dropSource = event.target.dataset.index
  }

  handleDragEnd = () => {
    this.dropSource = null
  }

  handleDrop = async event => {
    if (event.target.dataset.dragarea) {
      const sourceIndex = this.dropSource
      const targetIndex = event.target.dataset.change
      if (sourceIndex !== targetIndex && this.props.photos[sourceIndex]) {
        const photos = [...this.props.photos]
        const photo = this.props.photos[sourceIndex]
        photos.splice(sourceIndex, 1)
        photos.splice(targetIndex, 0, photo)
        this.props.setPhotos(photos.map((item, index) =>
          ({...item, priority: index, main: !index})
        ))
        this.dropSource = targetIndex
      }
    }
  }

  rotateLeft = event => {
    const isNewPhoto = !event.target.dataset.id
    const id = isNewPhoto ? event.target.dataset.tmpid : Number(event.target.dataset.id)
    const photo = isNewPhoto ? this.getPhotoByTmpId(id) : this.getPhotoById(id)
    if (photo.length) {
      this.imageManager.rotateLeft(photo[0].url).then(file => {
        if (isNewPhoto) {
          this.props.updatePhotoByTmpId(id, {...photo[0], url: file, isOriginal: false})
        } else {
          this.props.updatePhotoById(id, {...photo[0], url: file, isOriginal: false})
        }
      })
    }
  }

  rotateRight = async event => {
    const isNewPhoto = !event.target.dataset.id
    const id = isNewPhoto ? event.target.dataset.tmpid : Number(event.target.dataset.id)
    const photo = isNewPhoto ? this.getPhotoByTmpId(id) : this.getPhotoById(id)
    if (photo.length) {
      this.imageManager.rotateRight(photo[0].url).then(file => {
        if (isNewPhoto) {
          this.props.updatePhotoByTmpId(id, {...photo[0], url: file, isOriginal: false})
        } else {
          this.props.updatePhotoById(id, {...photo[0], url: file, isOriginal: false})
        }
      })
    }
  }

  handleDelete = async event => {
    const id = Number(event.target.dataset.id)
    const tmpId = event.target.dataset.tmpid
    if (id) {
      const photo = this.getPhotoById(id)
      if (photo.length) {
        await this.props.updatePhotoById(id, {id, destroy: true, isOriginal: true})
      }
    } else {
      const photo = this.getPhotoFromStateByTmpId(tmpId)
      if (photo.length) {
        this.dropzone.removeFile(photo[0].file)
        await this.props.deletePhoto(tmpId)
      }
    }
    const existingPhotos = this.props.photos.filter(item => !item.destroy).map((item, index) =>
      ({...item, priority: index, main: !index})
    )
    const deletedPhotos = this.props.photos.filter(item => item.destroy)
    await this.props.setPhotos([...existingPhotos, ...deletedPhotos])
    this.setState({...this.state, isPhotoCanBeAdded: this.isPhotoCanBeAdded()})
  }

  getPhotoById = id => this.props.photos.filter(photo => photo.id === id)

  getPhotoByTmpId = tmpId => this.props.photos.filter(photo => photo.tmpId === tmpId)

  getPhotoFromStateByTmpId = tmpId => this.state.newPhotos.filter(photo => photo.tmpId === tmpId)

  handleMaxFilesExceeded = file => {
    this.dropzone.removeFile(file)
  }

  getPhotoCount = () => this.props.photos.filter(item => item.id && !item.destroy).length + this.dropzone.files.length

  isPhotoCanBeAdded = () => this.getPhotoCount() < this.djsConfig.maxFiles

  isPhotoLimitExceeded = () => this.getPhotoCount() > this.djsConfig.maxFiles

  render () {
    const eventHandlers = {
      init: dz => {
        this.dropzone = dz
        this.setState({...this.state, isPhotoCanBeAdded: this.isPhotoCanBeAdded()})
      },
      addedfile: this.handleFileAdded,
      dragover: this.handleDrop,
      maxfilesexceeded: this.handleMaxFilesExceeded
    }
    const photos = this.props.photos.filter(item => !item.destroy)

    return [
      <div className='form-group-file' key='photos-upload'>
        {
          this.state.isLoading
            ? <Preloader />
            : <DropzoneComponent config={this.componentConfig} eventHandlers={eventHandlers} djsConfig={this.djsConfig}>
              <Preview
                photos={photos}
                dropSource={this.dropSource}
                handleDragStart={this.handleDragStart}
                handleDragEnd={this.handleDragEnd}
                rotateLeft={this.rotateLeft}
                rotateRight={this.rotateRight}
                remove={this.handleDelete}
                isPlusAvailable={this.state.isPhotoCanBeAdded}
              />
              <AddBtn isVisible={!photos.length} />
            </DropzoneComponent>
        }
      </div>,
      <Reminder key='photos-reminder' />
    ]
  }
}

Container.displayName = 'PhotoLoader'

const mapStateToProps = state => {
  const userInfo = getUserInfo(state)
  let photoLimit = 0
  let existingPhotos = []
  if (userInfo.packages && Array.isArray(userInfo.packages) && userInfo.packages.length) {
    photoLimit = userInfo.packages[0].photoLimit
  }
  if (userInfo.media && Array.isArray(userInfo.media)) {
    const gallery = userInfo.media.filter(item => item.title === 'gallery-image')
    if (gallery.length) {
      existingPhotos = gallery.map(({id, fd, priority, main}) => ({id, fd, priority, main}))
    }
  }
  return {
    photoLimit,
    photos: getServiceProviderPhotos(state),
    existingPhotos
  }
}

Container.propTypes = {
  photoLimit: PropTypes.number.isRequired,
  savePhoto: PropTypes.func.isRequired,
  deletePhoto: PropTypes.func.isRequired,
  updatePhotoById: PropTypes.func.isRequired,
  updatePhotoByTmpId: PropTypes.func.isRequired,
  setPhotos: PropTypes.func.isRequired,
  photos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    tmpId: PropTypes.string,
    url: PropTypes.string,
    name: PropTypes.string,
    destroy: PropTypes.bool
  })),
  existingPhotos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    fd: PropTypes.string.isRequired,
    priority: PropTypes.number.isRequired,
    main: PropTypes.bool
  }))
}

Container.defaultProps = {
  photoLimit: 0
}

export default connect(
  mapStateToProps,
  {
    savePhoto: saveServiceProviderPhoto,
    deletePhoto: deleteServiceProviderPhoto,
    updatePhotoById: updateServiceProviderPhotoById,
    updatePhotoByTmpId: updateServiceProviderPhotoByTmpId,
    setPhotos: setServiceProviderPhotos
  }
)(Container)
